import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';

type DialogContextType = {
  dialogCount: number;
  incrementDialog: () => void;
  decrementDialog: () => void;
};

const DialogContext = createContext<DialogContextType>({
  dialogCount: 0,
  incrementDialog: () => {},
  decrementDialog: () => {},
});

interface DialogProviderProps {
  children: ReactNode;
}

export const DialogProvider: React.FC<DialogProviderProps> = ({ children }) => {
  const [dialogCount, setDialogCount] = useState(0);

  const incrementDialog = useCallback(() => setDialogCount((count) => count + 1), []);
  const decrementDialog = useCallback(() => setDialogCount((count) => Math.max(count - 1, 0)), []);

  return (
    <DialogContext.Provider value={{ dialogCount, incrementDialog, decrementDialog }}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialogContext = () => useContext(DialogContext);
